import { _, Backbone, Obscura } from "../../vendor";

import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import Resourcetype from "../models/Resourcetype";

const ResourcetypesProxy = Obscura.extend({
  getResourcetypesList: function () {
    return ["Fahrzeuge", "E-Bikes"];
  },

  getFilterCount: function () {
    return this.getFilters().length;
  },

  /*  filterByQuery : function(val) {

    return this.filterBy('query', function(model){
      return model.get('id') === parseInt(val)
      || model.get('first_name').toLowerCase().indexOf(val) >= 0
      || model.get('last_name').toLowerCase().indexOf(val) >= 0
      || model.get('username').toLowerCase().indexOf(val) >= 0;
    });

}*/
});

export default InboomaBaseAsyncCollection.extend({
  collectionName: "resourcetypes",
  model: Resourcetype,
  url: "/resourcetypes",
  proxy: ResourcetypesProxy,

  _pagination: {
    // Updated after each request (response.pagination)
    current_page: 0,
    sort: "id",
    sortDirection: "desc",
    has_next_page: false,
    has_prev_page: false,
    count: 0, // not relevant; response total entities count
    limit: 50,
  },
});
